module.exports = __webpack_public_path__ + "media/veracruz/se_veracruz-0ad7a84a.png";